<template>
  <div class="box">
    <van-nav-bar safe-area-inset-top
        left-arrow
        @click-left="resultClick"
        @click-right="onClickRight"
        title="成色效果"
        right-text="完成"
        fixed
      />
    <div class="box-back">
      <van-cell @click="yearClick" is-link :value="recipeAddData.recipeYear">
        <template #title>
          <span class="custom-title">年款</span>
          <span class="required-style">(必填)</span>
        </template>
      </van-cell>
      <van-cell
        @click="vehicleClick"
        is-link
        :value="recipeAddData.carAgeDesc"
      >
        <template #title>
          <span class="custom-title">车龄(年)</span>
          <span class="required-style">(必填)</span>
        </template>
      </van-cell>
      <van-cell
        @click="territoryClick"
        v-if="!recipeAddData.isAdmin"
        is-link
        :value="recipeAddData.uploadRegionName"
      >
        <template #title>
          <span class="custom-title">上传/地域选择</span>
          <span class="required-style">(必填)</span>
        </template>
      </van-cell>
      <van-cell
        @click="colorArrClick"
        is-link
        :value="colorGroupName"
      >
        <template #title>
          <span class="custom-title">颜色组别</span>
          <span class="required-style">(必填)</span>
        </template>
      </van-cell>
      <van-row style="margin-top: 20px">
        <van-col span="1"></van-col>
        <van-col span="16">
          <span class="col-span">色差描述/使用建议</span>
        </van-col>
      </van-row>
      <van-row style="margin-top: 10px">
        <van-col span="1"></van-col>
        <div class="iptDeep">
          <van-col span="22">
            <van-field
              v-model="recipeAddData.commentInfo"
              maxlength="50"
              rows="2"
              autosize
              type="textarea"
              placeholder="评价一下产品色差......"
              show-word-limit
            />
          </van-col>
        </div>
        <van-col span="1"></van-col>
      </van-row>
      <van-row style="margin-top: 20px">
        <van-col span="1"></van-col>
        <van-col span="22">
          <span class="col-span">上传车身颜色效果图片</span>
        </van-col>
      </van-row>
      <van-row style="margin-top: 10px">
        <van-col span="1"></van-col>
        <van-col span="22">
          <van-uploader v-model="fileList" :after-read="afterRead" :before-delete='deleteRead' @oversize="onOversize" :max-count="2" />
        </van-col>
      </van-row>
      <van-cell title="车牌号" @click="plateNumberClick" is-link :value="recipeAddData.licenseNum" />
      <van-row style="margin-top: 20px">
        <van-col span="1"></van-col>
        <van-col span="16">
          <span class="col-span">备注（仅本店可见）</span>
        </van-col>
      </van-row>
      <van-row style="margin-top: 10px">
        <van-col span="1"></van-col>
        <div class="iptDeep">
          <van-col span="22">
            <van-field
              v-model="recipeAddData.recipeRemark"
              maxlength="50"
              rows="2"
              autosize
              type="textarea"
              placeholder="说些什么"
              show-word-limit
            />
          </van-col>
        </div>
        <van-col span="1"></van-col>
      </van-row>
    </div>
    <div class="btn">
      <van-button @click="endClick" round type="info">完成</van-button>
      <!-- 蒙层 -->
      <van-overlay :show="overlayShow">
        <div class="over-style">
          <van-loading color="#1989fa" />
        </div>
      </van-overlay>
    </div>
    <van-popup
      v-model="pickerShow"
      position="bottom"
      round
      :style="{ height: '38%' }"
    >
      <van-picker
        title="选择年款"
        show-toolbar
        default-index="1"
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
    <van-popup
      v-model="pickerVehicleShow"
      position="bottom"
      round
      :style="{ height: '38%' }"
    >
      <van-picker
        title="选择车龄"
        show-toolbar
        default-index="1"
        :columns="vehicleColumns"
        @confirm="vehicleOnConfirm"
        @cancel="vehicleOnCancel"
        
      />
    </van-popup>
    <van-popup
      v-model="pickerTerritoryShow"
      position="bottom"
      round
      :style="{ height: '38%' }"
    >
      <van-picker
        title="选择省份"
        show-toolbar
        default-index="1"
        :columns="TerritoryColumns"
        @confirm="TerritoryOnConfirm"
        @cancel="TerritoryOnCancel"
      />
    </van-popup>
    <van-popup
      v-model="colorArrShow"
      position="bottom"
      round
      :style="{ height: '38%' }"
    >
      <van-picker
        title="选择颜色"
        show-toolbar
        default-index="1"
        :columns="colorArrs"
        @confirm="colorConfirm"
        @cancel="coloraddCancel"
      />
    </van-popup>
    <van-popup
      v-model="keyValue"
      round
      position="bottom"
      :style="{ height: (cutShow ? '37%':'43%') }"
    >
    <div v-show="cutShow" class="key-box">
        <div class="key-box-title" style="margin-top:15px;">
            <div class="d1"><span @click="cutClick" class="d-span" style="color:rgb(92,126,252)">中/英</span></div>
            <div class="d2">
                <div><span class="d-span">{{plateNumber}}</span></div>
            </div>
            <div class="d3"><span @click="cancelClick" class="d-span d-span1" style="color:rgb(92,126,252)">取消</span></div>
        </div>
        <div class="key-value" style="margin-top:13px;">
            <div @click="keyVehicleNumClick(item)" v-for="(item,index) in keyVehicleNum1" :key="index" class="key-num">
                <span>{{item}}</span>
            </div>
        </div>
        <div class="key-value" style="margin-top:5px;">
            <div  @click="keyVehicleNumClick(item)" v-for="(item,index) in keyVehicleNum2" :key="index" class="key-num">
                <span>{{item}}</span>
            </div>
        </div>
        <div class="key-value" style="margin-top:5px;">
            <div  @click="keyVehicleNumClick(item)" v-for="(item,index) in keyVehicleNum3" :key="index" class="key-num">
                <span>{{item}}</span>
            </div>
            <div @click="deleteClick" class="key-num">
                <img class="key-num-X" src="../../assets/image/delete.png" alt="">
            </div>
        </div>
        <div class="key-value" style="margin-top:5px;">
            <div  @click="keyVehicleNumClick(item)" v-for="(item,index) in keyVehicleNum4" :key="index" class="key-num">
                <span>{{item}}</span>
            </div>
            <div class="key-num key-btn" @click="confirmClick" style="width: 16%;">
                    确定
            </div>
        </div>
    </div>
    <div  v-show="!cutShow" class="key-box">
        <div class="key-box-title" style="margin-top:15px;">
            <div class="d1"><span @click="cutClick" class="d-span" style="color:rgb(92,126,252)">中/英</span></div>
            <div class="d2">
                <div><span class="d-span">{{plateNumber}}</span></div>
            </div>
            <div class="d3"><span @click="cancelClick" class="d-span d-span1" style="color:rgb(92,126,252)">取消</span></div>
        </div>
        <div class="key-value" style="margin-top:13px;">
            <div @click="keyVehicleNumClick(item)" v-for="(item,index) in keyVehicle1" :key="index" class="key-num1">
                <span style="font-size:18px;">{{item}}</span>
            </div>
        </div>
        <div class="key-value" style="margin-top:13px;">
            <div @click="keyVehicleNumClick(item)" v-for="(item,index) in keyVehicle2" :key="index" class="key-num1">
                <span style="font-size:18px;">{{item}}</span>
            </div>
        </div>
        <div class="key-value" style="margin-top:13px;">
            <div @click="keyVehicleNumClick(item)" v-for="(item,index) in keyVehicle3" :key="index" class="key-num1">
                <span style="font-size:18px;">{{item}}</span>
            </div>
            <div @click="deleteClick" class="key-num1">
                <img class="key-num-X1" src="../../assets/image/delete.png" alt="">
            </div>
        </div>
        <div class="key-value" style="margin-top:13px;">
            <div @click="keyVehicleNumClick(item)" v-for="(item,index) in keyVehicle4" :key="index" class="key-num1">
                <span style="font-size:18px;">{{item}}</span>
            </div>
        </div>
    </div>
    </van-popup>
  </div>
</template>

<script>
import {mapState} from 'pinia'
import storeState from '../../store/index'  //storeId就是导出的那个值
import { compressImage } from "../../common/util";

const storeStates = storeState()

import Api from "../../api/api";
import { Toast } from 'vant';
export default {
  data() {
    return {
      // 车牌号键盘
      plateNumber: '',
      overlayShow: false, // 蒙层
      keyVehicleNum1: ['1','2','3','4','5','6','7','8','9','0'],
      keyVehicleNum2: ['Q','W','E','R','T','Y','U','I','O','P'],
      keyVehicleNum3: ['A','S','D','F','G','H','J','K','L'],
      keyVehicleNum4: ['Z','X','C','V','B','N','M'],
      keyVehicle1: ["京", "津", "沪", "陕", "冀", "豫", "云", "辽"],
      keyVehicle2: ["黑", "湘", "皖", "鲁", "新", "苏", "浙", "赣"],
      keyVehicle3: ["鄂", "桂", "甘", "晋", "蒙", "吉", "闽"],
      keyVehicle4: ["粤", "川", "青", "藏", "琼", "宁", "贵", "渝"],
      keyValue: false, // 车牌号弹框显示隐藏
      cutShow: false,  // 车牌号弹框中英文显示隐藏
      fileList: [], // 上传状态
      pickerShow: false, // 选择年款弹框
      pickerVehicleShow: false, // 选择车龄 弹框
      pickerTerritoryShow: false, // 选择省份 弹框
      colorArrShow: false,// 选择颜色 弹框
      // 日期
      columns: [
        "2025",
        "2024",
        "2023",
        "2022",
        "2021",
        "2020",
        "2019",
        "2018",
        "2017",
        "2016",
        "2015",
        "2014",
        "2013",
        "2012",
        "2011",
        "2010",
        "2009",
        "2008",
        "2007",
        "2006",
        "2005",
        "2004",
        "2003",
        "2002",
        "2001",
        "2000",
        "1999",
        "1998",
        "1997",
        "1996",
        "1995",
        "1994",
        "1993",
        "1992",
        "1991",
        "1990",
      ],
      vehicleColumns: [], // 选择车龄列表
      vehicleColumnsData: [], // 选择车龄数据记录
      TerritoryColumns: [], // 选择省份列表
      TerritoryColumnsData: [], // 选择省份数据记录
      colorArrs:[], // 选择颜色列表
      colorGroupName:"", // 颜色名称
      recipeAddData: { 
        // 国家
        countryCode: storeStates.countryCode,
        // 年款
        recipeYear:"",
        // 地域
        uploadRegionCode: '',
        uploadRegionName: '',
        imgList: [],// 上传照片
        // 适用车龄 100001
        carAge: '',
        // 适用车龄
        carAgeDesc: '',
        // 色差描述/使用建议
        commentInfo: '',
        // 备注配方
        recipeRemark: '',
        // 汽车品牌代码
        carBrandCode: '',
        // 汽车品牌名称
        carBrandName: '',
        // 车型代码
        carModelCode: '',
        // 车型名称
        carModelName: '',
        // 车型ID
        gdModelId: '',
        // 油漆品牌名称
        paintBrandName: '',
        // 油漆品牌代码
        paintBrandCode: '',
        // 油漆品牌图片
        paintBrandUrl: '',
        // 颜色ID
        gdColorId: '',
        // 是否是三工序
        isThree: null,
        // 工序的数据
        procedures: [],
        // 色号名字
        colorName: '',
        // 色号RGB
        colorRgb: '',
        // 色号Code
        colorCode: '',
        carOemCode:'',
        // 车牌号
        licenseNum:'',
        // 颜色组别
        colorGroup:"",
      },
    };
  },
  computed: {
    ...mapState(storeState,['addColor','colorData'])
    },
  created() {

    this.getUserInfo();
    // 颜色名称
    this.recipeAddData.colorName = storeStates.colorData.colorName;
    // 颜色Code
    this.recipeAddData.colorCode = storeStates.addColor.colorCode;
    // 颜色RGB
    this.recipeAddData.colorRgb = storeStates.addColor.colorRgb;
    // 工序的数据
    this.recipeAddData.procedures = storeStates.colorDataArrs;
    // 汽车品牌名称
    this.recipeAddData.carBrandName = storeStates.colorData.brandName;
    // 汽车品牌Code
    this.recipeAddData.carBrandCode = storeStates.addColor.carBrandCode;
    // 车型名称
    this.recipeAddData.carModelName = storeStates.colorData.modelName;
    // 车型code
    this.recipeAddData.carModelCode = storeStates.addColor.carModelCode;
    // 车型Id
    this.recipeAddData.gdModelId = storeStates.addColor.gdModelId;
    // 车型oemCode
    this.recipeAddData.carOemCode = storeStates.addColor.oemCode;
    // 油漆品牌名称
    this.recipeAddData.paintBrandName = storeStates.colorData.brandNameYQ;
    // 油漆品牌代码
    this.recipeAddData.paintBrandCode = storeStates.addColor.paintColor;
    // 油漆品牌图片
    this.recipeAddData.paintBrandUrl = storeStates.addColor.brandUrl;
    // 油漆品牌 颜色ID
    this.recipeAddData.gdColorId = storeStates.addColor.gdColorId;
    if (storeStates.colorData.isThree) {
        this.recipeAddData.isThree = '1'
    } else {
        this.recipeAddData.isThree = '0'
    }
    // brandUrl
    Api.keyValue(1004).then((res) => {
      for (let index = 0; index < res.data.result.length; index++) {
          this.vehicleColumns.push(res.data.result[index].itemValue);
          this.vehicleColumnsData.push(res.data.result[index]);
      }
    });
    let provinceData = {
      countryCode: storeStates.countryCode
    }
    Api.province(provinceData).then((res) => {
      for (let index = 0; index < res.data.result.length; index++) {
        this.TerritoryColumns.push(res.data.result[index].provinceName);
        this.TerritoryColumnsData.push(res.data.result[index]);
      }
    });
    // 颜色组别
    Api.keyValue(1006).then((res) => {
      for (let index = 0; index < res.data.result.length; index++) {
        let datas = {text:"",value:""}
        datas.text = res.data.result[index].itemValue;
        datas.value = res.data.result[index].itemKey;
        this.colorArrs.push(datas)
      }
    });
  },
  methods: {
    resultClick() {
      this.$router.push({
        path: "/app-h5-cn/page/addColor",
        query:{
          storeStateState: '1'
        }
      });
    },
    // 上传图片
    afterRead(file) {
      file.status = 'uploading';
      file.message = '上传中...';

      let compressImageFun = compressImage(file);
      compressImageFun.then((res) => {
        Api.uploadImg(res).then((res) => {
          if (res.status === 200) {
            file.status = 'done';
            let imgData = {
              imgId: res.data.result.imgId,
              imgUrl: res.data.result.imgUrl,
            }
            this.recipeAddData.imgList.push(imgData);
          } else {
            file.status = 'failed';
            file.message = '上传失败';
          }
        });
      })
    },
    // 删除图片
    deleteRead(event,index) {
      this.recipeAddData.imgList.splice(index,1);
      this.fileList.splice(index,1);
    },
    // 图片大小限制
    onOversize() {
      Toast('文件大小不能超过 1M');
    },
    //获取用户信息
    getUserInfo() {
      // 查询用户信息
      Api.userInfo({}).then((res) => {
          if (res.data.success) {
            if(res.data.result){
              this.recipeAddData.isAdmin =  res.data.result.businessName?false:true;
              this.recipeAddData.uploadRegionCode = res.data.result.provinceCode;
              this.recipeAddData.uploadRegionName = res.data.result.provinceName;
            }
          } else {
            Toast.fail(res.data.msg?res.data.msg:'查询用户信息失败');
          }
      })
    },
    
    // 选择年款的 索引
    onConfirm(value) {
      this.recipeAddData.recipeYear = value*1;
      this.pickerShow = false;
    },
    vehicleOnConfirm(value, index) {
      this.recipeAddData.carAgeDesc = value;
      this.recipeAddData.carAge = this.vehicleColumnsData[index].itemKey;

      this.vehicleValue = value;
      this.pickerVehicleShow = false;
    },
    vehicleOnCancel() {
      this.pickerVehicleShow = false;
    },
    TerritoryOnConfirm(value, index) {
      this.recipeAddData.uploadRegionName = value;
      this.recipeAddData.uploadRegionCode = this.TerritoryColumnsData[index].provinceCode;
      this.pickerTerritoryShow = false;
    },
    colorConfirm(value, index) {
      this.recipeAddData.colorGroup = value.value;
      this.colorGroupName = value.text;
      this.colorArrShow = false;
    },
    TerritoryOnCancel() {
      this.pickerTerritoryShow = false;
    },
    coloraddCancel() {
      this.colorArrShow = false;
    },
    // 选择年款,取消
    onCancel() {
      this.pickerShow = false;
    },
    yearClick() {
      this.pickerShow = true;
    },
    plateNumberClick() {
        this.keyValue = true;
    },
    vehicleClick() {
      this.pickerVehicleShow = true;
    },
    territoryClick() {
      this.pickerTerritoryShow = true;
    },
    colorArrClick() {
      this.colorArrShow = true;
    },
    //校验新增配方参数
    checkAddRecipeValue() {
     
      if(!this.recipeAddData.recipeYear){
        Toast.fail('选择年款');
        return true;
      }

      if(!this.recipeAddData.carAge){
        Toast.fail('选择车龄');
        return true;
      }
      
      if(!this.recipeAddData.isAdmin&&!this.recipeAddData.uploadRegionCode){
        Toast.fail('选择上传地域');
        return true;
      }
      

      if(!this.recipeAddData.colorGroup){
        Toast.fail('选择颜色组别');
        return true;
      }
      
      return false;
    },

    endClick() {
       console.log("this.recipeAddData:",this.recipeAddData);
      if(this.checkAddRecipeValue()){
        return;
      }
      this.overlayShow = true;
      // 新增配方
      Api.recipeAdd(this.recipeAddData).then((res) => {
          this.overlayShow = false;
          if (res.data.success) {
            // useRecipeResult 四种状态 0:异常,1:使用配方,2:新增配方,3:相似配方,4:待审核配方
            if (res.data.result.useRecipeResult == 0) {
              Toast.fail(res.data.result.errorMsg?res.data.result.errorMsg:'新增配方失败');
            } else if (res.data.result.useRecipeResult == 1) {
              storeStates.recipeNo = res.data.result.recipeNo;
              storeStates.recipeQueryType = "2";
              storeStates.searchState = '';
              this.$router.push('/app-h5-cn/page/uploadFail');
            } else if (res.data.result.useRecipeResult == 2) {
              storeStates.recipeNo = res.data.result.recipeNo;
              storeStates.recipeQueryType = "2";
              storeStates.searchState = '';
              // 上传成功，把缓存的色号清楚(避免新增时带上次的数据)
              storeStates.processArrColor = [];
              storeStates.processArrColor2 = [];
              storeStates.processArrColor3 = [];
              storeStates.processWeightData = [];
              storeStates.processWeightData2 = [];
              storeStates.processWeightData3 = [];
              this.$router.push({
                path: '/app-h5-cn/page/uploadSucceed',
                query: {
                  pointNum: res.data.result.pointNum,
                }
              });
            }  else if (res.data.result.useRecipeResult === 3) {
              storeStates.recipeNo = res.data.result.recipeNo;
              storeStates.recipeQueryType = "2";
              // Toast.fail(res.data.result.errorMsg);
              // 上传失败
              this.$router.push({
                path: '/app-h5-cn/page/uploadFail',
              });
            }
          } else {
            Toast.fail(res.data.msg?res.data.msg:'新增配方失败');
          }
      })
    },
    keyVehicleNumClick(val) {
        let plateNumVal = this.plateNumber
        if (this.plateNumber.length<15) { 
            console.log(val);
            let value = plateNumVal+val;
            this.plateNumber = value;
            
        }
        console.log(this.plateNumber);
        
    },
    deleteClick() {
        let plateNumVal = this.plateNumber;
        if (this.plateNumber.length > 0) {
            let plateNumArr = plateNumVal.split('');
            let plate = plateNumArr;
            plate.pop()
            let as = plate;
            let joins = as.join('');
            this.plateNumber = joins;
        }
    },
    confirmClick() {
        this.recipeAddData.licenseNum = this.plateNumber;
        this.keyValue = false;
    },
    // 取消车牌输入
    cancelClick() {
        this.keyValue = false;
    },
    // 切换输入法
    cutClick() {
        if (this.cutShow) {
            this.cutShow = false;
        } else {
            this.cutShow = true;
        }
    },
    onClickRight() {
      this.endClick();
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  background-color: white;
  width: 100%;
}
.box-back {
  margin-top: 2.9rem;
  width: 100%;
  background-color: white;
}
.nav-box {
  width: 100%;
  height: 2.9rem;
  background-color: white;
  .van-col-title {
    display: flex;
    justify-content: center;
    h3 {
      line-height: 0.75rem;
      font-size: 1rem;
    }
  }
  .van-col-icon {
    margin-top: 0.7rem;
    margin-left: 8px;
  }
  .img-div {
    display: flex;
    justify-content: space-around;
    .img-siz {
      margin-top: 0.7rem;
      width: 1.4rem;
      float: right;
    }
  }
}
.btn {
  width: 100%;
  margin-top: 40px;
  display: flex;
  justify-content: center;
}
/deep/ .van-field__control {
  background-color: rgb(243, 243, 249);
}
.iptDeep {
  /deep/ .van-cell {
    background-color: rgb(243, 243, 249);
    border-radius: 10px;
  }
}

/deep/ .van-field__label {
  font-size: 1.1rem;
  font-weight: 300;
}
/deep/ .van-field__control {
  font-size: 13px;
  font-weight: 300;
  color: black;
}
/deep/ .van-button--round {
  width: 200px;
}
.key-box {
    width: 100%;
    height:  calc(100% -10px);
}
.key-box-title {
    width: 94%;
    margin-left: 3%;
    height: 35px;
    // background-color: red;
    display: flex;
    
    .d1 {
        width: 20%;
        height: 35px;
        // background-color: rgb(127, 138, 134);
    }
    .d2 {
        width: 60%;
        height: 35px;
        display: flex;
        justify-content: center;
        // background-color: white;
    }
    .d3 {
        width: 20%;
        height: 35px;
        line-height: 35px;
        // background-color: rgb(127, 138, 134);
    }
    .d-span {
        font-size: 18px;
        line-height: 35px;
        text-align: center;
    }
    .d-span1 {
        float: right;
    }
}
.span-size {
  font-size: 25px;
  color: red;
  margin-top: 5px;
}
.key-value {
    width: 96%;
    height: 38px;
    margin-left: 2%;
    background-color: white;
    display: flex;
    justify-content: space-between;
    .key-num {
        width: 8%;
        height: 36px;
        border: solid 1px rgb(175, 170, 170);
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        span{
            line-height: 36px;
            font-size: 16px;
        }
    }
    .key-num1 {
        width: 11%;
        height: 36px;
        border: solid 1px rgb(175, 170, 170);
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        span{
            line-height: 36px;
            font-size: 16px;
        }
    }
    .key-num-X {
        width: 70%;
    }
    .key-num-X1 {
        width: 56%;
    }
    .key-btn {
        color: white;
        background-color: rgb(92,126,252);
    }
}
/deep/ .van-cell {
  font-size: 13px;
  color: black;
}
.col-span {
  font-size: 13px;
  color: black;
}
// 导航头
/deep/ .van-nav-bar__title {
  color: black !important;
  font-size: 1rem;
  font-weight: 600;
}
/deep/ .van-nav-bar .van-icon {
  color: black;
}
.over-style {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.span-size-pos {
  font-size: 13px;
  color: red;
  position: relative;
  top: -4px;
  margin-left: 4px;
}
.required-style {
  color: red;
  font-size: 13px;
  margin-left: 4px;
}
</style>